require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./category-health-and-fitness.json") })
        }
      }, "path---category-health-and-fitness");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---category-health-and-fitness!./.cache/json/category-health-and-fitness.json
// module id = 303
// module chunks = 231608221292675